module.exports = __webpack_public_path__ + "img/video_close.83725eb.png";